import axiosInstance from "../utils/axiosInstance";
import { URLS } from "../utils/baseUrls";

// Request bodies are written in camelCase — axiosInterceptors converts them
// to snake_case on the wire, and converts snake_case responses back to
// camelCase, so these functions just pass res.data straight through.

const kydCheckout = async (userId, tier = 1) => {
  const res = await axiosInstance.post(`${URLS.payments}/kyd/checkout/`, {
    userId,
    tier,
  });
  return res.data;
};

const kydCashPayment = async (userId, tier = 1) => {
  const res = await axiosInstance.post(`${URLS.payments}/kyd/cash-payment/`, {
    userId,
    tier,
  });
  return res.data;
};

const kydRfCode = async (
  userId,
  { sendSms = false, description = "", phone = "" } = {}
) => {
  const res = await axiosInstance.post(`${URLS.payments}/rf-codes/`, {
    userId,
    description,
    sendSms,
    phone,
  });
  return res.data;
};

const kydResendRfSms = async (userId, phone = "") => {
  const res = await axiosInstance.post(
    `${URLS.payments}/rf-codes/resend-sms/`,
    { userId, phone }
  );
  return res.data;
};

const kydCancelRfCode = async (rfCodeId) => {
  const res = await axiosInstance.post(
    `${URLS.payments}/rf-codes/${rfCodeId}/cancel/`
  );
  return res.data;
};

// The requesting farmer's own RF code still awaiting payment. The backend
// answers 200 with an empty body (not null) when there is none.
const fetchMyPendingRfCode = async () => {
  const res = await axiosInstance.get(`${URLS.payments}/my-pending-rf-code/`);
  return res.data || null;
};

const fetchRfCodes = async () => {
  const res = await axiosInstance.get(`${URLS.payments}/rf-codes/`);
  return res.data;
};

const fetchPlans = async ({ audience, tier } = {}) => {
  const res = await axiosInstance.get(`${URLS.payments}/plans/`, {
    params: { audience, tier },
  });
  return res.data;
};

const fetchDynamicComparison = async (tier) => {
  const res = await axiosInstance.get(
    `${URLS.payments}/plans/dynamic-comparison/`,
    { params: { tier } }
  );
  return res.data;
};

const fetchMySubscription = async () => {
  try {
    const res = await axiosInstance.get(`${URLS.payments}/my-subscription/`);
    return res.data;
  } catch (err) {
    if (err.response?.status === 404) return null;
    throw err;
  }
};

const farmerCheckout = async (tier = 1) => {
  const res = await axiosInstance.post(`${URLS.payments}/checkout/farmer/`, {
    tier,
  });
  return res.data;
};

const agronomistCheckout = async (tier = 1) => {
  const res = await axiosInstance.post(
    `${URLS.payments}/checkout/agronomist/`,
    { tier }
  );
  return res.data;
};

export const paymentsApi = {
  kydCheckout,
  kydCashPayment,
  kydRfCode,
  kydResendRfSms,
  kydCancelRfCode,
  fetchMyPendingRfCode,
  fetchRfCodes,
  fetchPlans,
  fetchDynamicComparison,
  fetchMySubscription,
  farmerCheckout,
  agronomistCheckout,
};
